import { render, staticRenderFns } from "./InspCat1Input.vue?vue&type=template&id=f70d4874&"
import script from "./InspCat1Input.vue?vue&type=script&lang=js&"
export * from "./InspCat1Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports